import { Col, Row } from "reactstrap";
import { Btn, H5 } from "../../../AbstractElements";

type Props = {
  onYesClick: () => void;
  centeredToggle: () => void;
};

export function YesNo({ centeredToggle, onYesClick }: Props) {
  return (
    <Col>
      <Row>
        <H5 className="text-center">
          Are you sure you want to delete the user?
        </H5>
      </Row>
      <Row>
        <Btn
          color="dark"
          className="rounded-pill w-100 mt-4"
          onClick={onYesClick}
        >
          {"Yes"}
        </Btn>

        <Btn
          color="white"
          className="rounded-pill w-100 dark-toggle-btn"
          onClick={centeredToggle}
        >
          {"No"}
        </Btn>
      </Row>
    </Col>
  );
}
